import { z } from "zod";
import { ClientFileReport, ClientFileReportType } from "../clientFile";

export const schema = {
    latest: {
        input: z.object({
            type: ClientFileReportType,
        }),
        output: z.object({ reports: z.array(ClientFileReport) }),
    },
    getDownloadUrl: {
        input: z.object({
            key: z.string(),
        }),
        output: z.object({
            downloadUrl: z.string(),
        }),
    },
};
